export const chaveArmazenamentoToken = "Onboarding-token";
export const chaveArmazenamentoIdSessao = "Onboarding-idSessao";
export const codigoDLE = "DLE";
export const codigoDGK = "DGK";
export const codigoDGKPSC = "DGK_PSC";
export const codigoToxicologia = "TOX";
export const tiposClienteEspecificos = [
  codigoDGK,
  codigoDLE,
  codigoToxicologia,
];
export const LIMITE_CHARS_USUARIO = 20;
export const LIMITE_CHARS_SENHA = 20;
export const LIMITE_CHARS_NUMERO_ETIQUETA_AMOSTRA = 13;
export const LIMITE_CHARS_NUMERO_ETIQUETA_LOTE = 12;
export const LIMITE_CHARS_ESPECIFICACAO = 100;
export const LIMITE_CHARS_NOME_PACIENTE = 75;
export const LIMITE_CHARS_NUMERO_PEDIDO = 20;
export const CODIGO_TECLA_S = 83;
export const CODIGO_TECLA_U = 85;
export const CODIGO_TECLA_P = 80;
export const CODIGO_TECLA_ESC = 27;
export const USA_APPLET_SIM = "S";
export const USA_APPLET_ZEBRA = "Z";
export const codigoLoteEmRascunho = "E0";
export const codigoMontagemDeLote = "E1";
export const statusLotePreenchimento = "(Rascunho)";
export const codigoTipoLoteNormal = -1;
export const codigoTipoLoteAmostrasEspeciais = 10;
export const codigosErros = {
  AmostraEmOutroLote: "AMOSTRA_EM_OUTRO_LOTE",
  AmostraNaoExisteNoLote: "AMOSTRA_NAO_EXISTENTE_NO_LOTE",
  AmostraJaCadastrada: "AMOSTRA_JA_CADASTRADA",
};
export const LISTAGEM_VAZIA_FILTROS =
  "Não existem resultados para essa combinação de filtros.";
export const LISTAGEM_VAZIA_AMOSTRAS_DISPONIVEIS =
  "Não existem mais amostras disponíveis para inclusão no momento!\nVeja a listagem de amostras no lote ou conclua a criação do lote.";
export const LISTAGEM_VAZIA_AMOSTRAS_NO_LOTE =
  "Não há amostras cadastradas no lote.\nUse o leitor de código de barras ou cadastre-as manualmente";

export const TAMANHO_MAXIMO_ARQUIVOS_AMOSTRA = 5;
export const EXTENSOES_ARQUIVOS_AMOSTRA = ".pdf, .png, .jpeg, .jpg";

export const mensagemErroPadrao = "Ocorreu um erro ao executar a operação.";

export const mensagemRelatorioUtilizacaoVazio =
  "O usuário logado não possui laboratórios vinculados.";

export const mensagemEtiquetaDadoEnvioVazio =
  "O laboratório não possui vínculo com a base logística. Verifique com o executivo.";

export const CODIGO_EMPRESA_IHP = "IHP";

export const STATUS_VOUCHER_GERADO_AUTOMATICAMENTE = 7;

export const TIPO_LOTE_KPA_CODIGO = 0;

export const EXTENSAO_ARQUIVO_EXCEL = "xlsx";
export const NOME_ARQUIVO_DADOS_LOTE = "DadosLote";
export const NOME_ARQUIVO_RELATORIO_DE_UTILIZACAO =
  "Relatório_de_Utilização_Onboarding_";
export const NOME_ARQUIVO_LISTAGEM_DE_AMOSTRAS = "Listagem_de_Amostras_";
export const NOME_ARQUIVO_LISTAGEM_DE_LOTES = "Listagem_de_Lotes_";

export const TIPO_CONSERVACAO_AMOSTRA = [
  {
    id: 1,
    descricao: "Ambiente",
    codigo: "A",
  },
  {
    id: 2,
    descricao: "Refrigerado",
    codigo: "R",
  },
  {
    id: 3,
    descricao: "Congelado",
    codigo: "C",
  },
];

export const MENSAGEM_PADRAO_TROCA_LABORATORIO = "Utilize o campo de busca acima para ver os laboratórios.";
export const MENSAGEM_NAO_EXISTEM_LABORATORIOS = "Não existem laboratórios para o termo pesquisado.";
